import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';

import { ChildrenProps } from 'types/children';

import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';
import { mobileOnly } from 'styles/utils';

const titleCss = (colors: IColors) => css`
	font-size: 1.6rem;
	font-weight: bold;
	color: ${colors.tx_text_primary};
`;

const rowLayoutCss = (colors: IColors) => css`
	border-bottom: 1px solid ${colors.bg_border_primary};
	margin-bottom: 44px;
	padding-bottom: 24px;
	${mobileOnly} {
		margin-bottom: 36px;
	}
`;

interface TitleProps {
	title: string;
}

interface Props {
	divider?: boolean;
	children: React.ReactNode;
}

function RowLayout({ divider, children }: Props) {
	const { colors } = useColors();
	return <Grid css={divider && rowLayoutCss(colors)}>{children}</Grid>;
}

function Title({ title }: TitleProps) {
	const { colors } = useColors();
	return <>{<h2  data-testid="Row-6CF5F5" css={titleCss(colors)}>{title}</h2>}</>;
}

function Content({ children }: ChildrenProps) {
	return <>{children}</>;
}

RowLayout.Title = Title;
RowLayout.Content = Content;

export default RowLayout;
